var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.4375 14.3184V18.8184H18.4375V14.3184H0.4375ZM16.9375 17.3184H1.9375V15.8184H16.9375V17.3184Z",
    fill: "#4C4A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9376 4.19336C12.9274 3.1861 11.6053 2.55149 10.1876 2.39336V0.818359H8.6876V2.39336C7.13632 2.5605 5.70225 3.29735 4.66309 4.46121C3.62393 5.62506 3.05363 7.13312 3.0626 8.69336V10.5684H6.0626V12.8184H7.5626V10.5684H11.3126V12.8184H12.8126V10.5684H15.8126V8.69336C15.8233 7.85509 15.6625 7.02349 15.34 6.24964C15.0176 5.47579 14.5403 4.77604 13.9376 4.19336ZM14.3126 9.06836H4.5626V8.69336C4.5626 7.40043 5.07622 6.16045 5.99046 5.24621C6.9047 4.33197 8.14467 3.81836 9.4376 3.81836C10.7305 3.81836 11.9705 4.33197 12.8847 5.24621C13.799 6.16045 14.3126 7.40043 14.3126 8.69336V9.06836Z",
    fill: "#4C4A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.85561764.svg";
export { ForwardRef as ReactComponent };